import { IS_TRAINING } from "@/lib/env";

// Badge discreto ma sempre riconoscibile mostrato SOLO quando ENVIRONMENT_MODE=TRAINING.
// In produzione (variabile assente) non renderizza nulla: nessun impatto visivo/funzionale.
export function TrainingBadge() {
  if (!IS_TRAINING) return null;
  return (
    <div data-testid="training-badge" aria-label="Ambiente TRAINING"
      className="fixed top-2 left-1/2 -translate-x-1/2 z-[9999] pointer-events-none select-none">
      <span className="inline-flex items-center gap-1.5 rounded-full border border-amber-500 bg-amber-100/95 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-amber-800 shadow-sm backdrop-blur-sm">
        <span className="h-2 w-2 rounded-full bg-amber-500 animate-pulse" />
        Training
      </span>
    </div>
  );
}

export default TrainingBadge;
